module.exports = __webpack_public_path__ + "static/media/magnifying-glass-left.bbaa611c.svg";